/**
 * Descripción: instancia de vue
 *
 * @displayName main.js
 */

import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import '@/plugins/core';
import 'nprogress/nprogress.css';

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  created() {
    const userString = localStorage.getItem('user');
    const statusNavbar = localStorage.getItem('status');
    if (userString) {
      const userData = userString;
      store.commit('authentication/SET_USER_DATA', userData, {
        root: true
      });
    }

    statusNavbar != null
      ? store.commit('navbar/UPDATE_STATUS_DATA', statusNavbar, { root: true })
      : store.commit('navbar/UPDATE_STATUS_DATA', false, { root: true });
  },
  render: h => h(App)
}).$mount('#app');
